export default "__VITE_ASSET__DBLDLwbk__"